export default __webpack_public_path__ + "250d0eaa63ebc49ccf9264bd87781f4b.svg";